/*-----------------------------------------------------------------------------
 *  The initial developer of the original code is Plastimold Products
 *
 *  Contains unpublished trade secrets of Plastimold Products
 *  Delray Beach, FL, USA.
 *
 *  (C) Copyright 2022 Plastimold Products
 *
 *             ALL RIGHTS RESERVED
 * ----------------------------------------------------------------------------
 */

import i18n from '../i18n'

import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { useSWRConfig } from 'swr'

import serverapi from '../core/server'
import { Form, TextField, Submit } from './forms'

const onValidate = values => {
    const errors = {}
    if (values.deleteMe !== 'delete') {
        errors.deleteMe = i18n.t('Please type "delete" to confirm')
    }
    return errors
}

const initialValues = {
    deleteMe: '',
}

const DeleteAccountDialog = ({ isOpen, onComplete }) => {
    const { mutate } = useSWRConfig()

    const onSubmit = ({ setSubmitting }) => {
        setSubmitting(true)
        serverapi.deleteAccount(mutate).finally(() => {
            setSubmitting(false)
        })
    }

    const onCancel = () => onComplete(false)

    return (
        <Modal show={isOpen} onHide={onCancel}>
            <Form initialValues={initialValues} onValidate={onValidate} onSubmit={onSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>{ i18n.t('Delete Account') }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{ i18n.t('You are about to delete your account.  All card data will be permanently deleted and your subscription cancelled.') }</p>
                    <p>{ i18n.t('Please enter "delete" in the box below to confirm') }</p>
                    <TextField name="deleteMe" type="text" placeholder="delete" />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={onCancel}>{ i18n.t('Cancel') }</Button>
                    <Submit variant="danger">{ i18n.t('Delete Account') }</Submit>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default DeleteAccountDialog
